import type { Transformer } from './transformer';

export const removeMkdocsHeader = (): Transformer => {
  return dom => {
    // Remove the header
    dom.querySelector('.md-header')?.remove();

    return dom;
  };
};